import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { LayoutDashboard, Package, ListTree, LogOut } from "lucide-react";
//import "./AdminSidebar.css"; // optional custom styles

const AdminSidebar = ({ children }) => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  return (
    <div className="d-flex">
      {/* Sidebar */}
      <div
        className={`sidebar bg-dark text-white p-3 ${
          collapsed ? "collapsed" : ""
        }`}
        style={{
          minHeight: "100vh",
          width: collapsed ? "70px" : "240px",
          transition: "width 0.3s",
        }}
      >
        <button
          className="btn btn-outline-light mb-4 w-100"
          onClick={toggleSidebar}
        >
          {collapsed ? "»" : "«"}
        </button>

        <ul className="nav flex-column">
          <li className={`nav-item mb-2`}>
            <Link
              to="/admin/dashboard"
              className={`nav-link text-white d-flex align-items-center ${
                location.pathname.includes("dashboard") ? "active" : ""
              }`}
            >
              <LayoutDashboard size={18} className="me-2" />
              {!collapsed && "Dashboard"}
            </Link>
          </li>
          <li className={`nav-item mb-2`}>
            <Link
              to="/admin/products"
              className={`nav-link text-white d-flex align-items-center ${
                location.pathname.includes("products") ? "active" : ""
              }`}
            >
              <Package size={18} className="me-2" />
              {!collapsed && "Products"}
            </Link>
          </li>
          <li className={`nav-item mb-2`}>
            <Link
              to="/admin/categories"
              className={`nav-link text-white d-flex align-items-center ${
                location.pathname.includes("categories") ? "active" : ""
              }`}
            >
              <ListTree size={18} className="me-2" />
              {!collapsed && "Categories"}
            </Link>
          </li>

          <li className={`nav-item mb-2`}>
            <Link
              to="/admin/orders"
              className={`nav-link text-white d-flex align-items-center ${
                location.pathname.includes("orders") ? "active" : ""
              }`}
            >
              <ListTree size={18} className="me-2" />
              {!collapsed && "Orders"}
            </Link>
          </li>

          <li className={`nav-item mb-2`}>
            <Link
              to="/admin/gifts"
              className={`nav-link text-white d-flex align-items-center ${
                location.pathname.includes("gifts") ? "active" : ""
              }`}
            >
              <ListTree size={18} className="me-2" />
              {!collapsed && "Gifts"}
            </Link>
          </li>





          <li className="nav-item mt-4">
            <Link
              to="/admin/logout"
              className="nav-link text-danger d-flex align-items-center"
            >

              <LogOut size={18} className="me-2" />
              {!collapsed && "Logout"}
            </Link>
          </li>
        </ul>
      </div>

      {/* Main Content */}
      <div
        className="content flex-grow-1 p-3"
        style={{ overflowY: "auto", height: "100vh" }}
      >
        {children}
      </div>
    </div>
  );
};

export default AdminSidebar;
